import React from 'react';

export default function Resume() {
  return (
    <section id="resume" className="py-16 px-6 text-center">
      <h3 className="text-3xl font-bold mb-4">Resumé</h3>
      <a href="/files/Ali-Fayed-Resume-2026.pdf" target="_blank" rel="noreferrer" className="bg-teal-500 px-6 py-2 rounded text-white hover:bg-teal-600">
        Download Resumé
      </a>
    </section>
  );
}
